import React, { useCallback, useState } from "react";
import { Card, Button, Col, Row, CardBody, CardFooter } from "reactstrap";
import closeOutline from "../../../assets/icons/close-outline.svg";
import store from "../../../assets/icons/store.svg";

import I18n from "../../../../i18n/utils";
import CFASpinner from "../../Common/CFASpinnner/CFASpinner";
import success from "../../../assets/icons/success-icon.svg";
import "./riskInformationSaveModal.scss";

import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/store/store";
import { getUserPermissions } from "../../../utils/LocalStorage";
import {
  alertRefreshScoresInformation, refundAnalysisDuplicateRequestedFeedbackSelector,
  resetSaveAllStatus,
  saveAllRefundAnalysisInformation,
} from "../../../redux/features/refundAnalysisSlice";
import moment from "moment/moment";
import RefundAnomaly from "../../../interfaces/RefundAnomaly";
import RefundAnomalyScore from "../../../interfaces/RefundAnomalyScore";

function RiskInformationSaveModal(props: any) {
  const [validationError, setValidationError] = useState<string>("");
  const duplicateFeedbackRequests: RefundAnomaly[] = useSelector(refundAnalysisDuplicateRequestedFeedbackSelector);
  const dispatch = useDispatch();

  function modifiedScoreCount() {
    let modifiedScoreCount = 0;
    for (const [key, value] of props.riskRecordsModified.current) {
      for (const score of value) {
        modifiedScoreCount++;
      }
    }
    return modifiedScoreCount;
  }

  function submit() {
    dispatch(
      saveAllRefundAnalysisInformation(props.riskRecordsModified.current)
    );
    props.riskRecordsModified.current.clear();
  }
  const close = useCallback(() => {
    dispatch(resetSaveAllStatus());
    props.close(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const closeSuccess = useCallback(() => {
    dispatch(resetSaveAllStatus());
    dispatch(alertRefreshScoresInformation());
    props.riskRecordsModified.current.clear();
    props.close(true);
  }, []);

  let error = false;

  const errorStatus = useSelector(
    (state: RootState) => state.refundAnalysisInformation.saveAllStatus
  );

  const checkUserPerms = () => {
    const treasuryPermissions = getUserPermissions();
    return (
      treasuryPermissions.hasOwnProperty("SHERLOCK_ADMIN") ||
      treasuryPermissions.hasOwnProperty("SUPERUSER")
    );
  };

  if (errorStatus === "failed") {
    error = true;
  }

  const errorMessage = useSelector(
    (state: RootState) => state.refundAnalysisInformation.error
  );

  const formatFeedbackToBeSaved = () => {
    let savedScores: any[] = [];

    let modifiedScores = props.riskRecordsModified.current;

    for (const [key, value] of modifiedScores) {
      let scoreFeedbackToSave: any;
      let editedAnomalies: any[] = [];
      let operatorName = "";
      let operatorPreferredName = "";
      let operatorEmail = "";
      let financialConsultant = "";
      let financialConsultantEmail = "";
      let endTime = "";

      for (const score of value) {
        operatorName = score.operatorName;
        operatorPreferredName = score.operatorPreferredName;
        operatorEmail = score.operatorEmail;
        financialConsultant = score.financialConsultant;
        financialConsultantEmail = score.financialConsultantEmail;
        if (score.endTime !== undefined) {
          endTime = moment.utc(score.endTime, moment.ISO_8601).format("h:mm A");
        }
        editedAnomalies.push({
          transactionId: score.transactionId,
          riskLevel: score.refundAnomalyScoreRead.riskLevel,
          emailConsultant: score.emailFrc,
          emailOperator: score.emailOperator,
          transactionDate: score.businessDate,
          endTime: endTime,
          outputRefundAmount: score.outputRefundAmount,
          refundType: score.refundType,
        });
      }
      scoreFeedbackToSave = {
        locationNumber: key,
        operator: {
          name: operatorName,
          email: operatorEmail,
        },
        operatorPreferredName: operatorPreferredName,
        financialConsultant: {
          name: financialConsultant,
          email: financialConsultantEmail,
        },
        anomalies: editedAnomalies,
      };
      savedScores.push(scoreFeedbackToSave);
    }
    dispatch(saveAllRefundAnalysisInformation(savedScores));
  };

  const saveForm = (
    <Row>
      <Col className="dashboard-card">
        <Card className="dashboard-card">
          <CardBody>
            <Row className="close-button-container">
              <img
                alt=""
                src={closeOutline}
                className="close-modal-icon"
                onClick={close}
              />
            </Row>
            <Row className="container">
              <Col className="bu-override-import-title-container">
                <img
                  alt=""
                  src={store}
                  className="bu-override-import-title-icon"
                />
                <h2 className="bu-override-import-title">
                  {I18n.t("RISK_ANALYSIS_SAVE_MODAL_TITLE")}
                </h2>
              </Col>
            </Row>
            <Row className="input-row">
              <h3>
                {" "}
                There {modifiedScoreCount() === 1 ? "is" : "are"}{" "}
                {modifiedScoreCount()} modified{" "}
                {modifiedScoreCount() > 1 || modifiedScoreCount() == 0
                  ? "records"
                  : "record"}{" "}
              </h3>
            </Row>
            {/*{dataPreview}*/}
            {error && (
              <Row>
                  <h4 className="error">{errorMessage}</h4>
              </Row>
            )}
            {validationError && (
              <Row>
                <h4 className="error">{validationError}</h4>
              </Row>
            )}
            <CardFooter>
              {!props.loading ? (
                <Row className="align-items-center">
                  <Button
                    disabled={
                      props.riskRecordsModified.current == undefined ||
                      props.riskRecordsModified.current.size == 0 ||
                      props.userEmailValidated == false ||
                      !checkUserPerms()
                    }
                    className="submit-button-save"
                    onClick={formatFeedbackToBeSaved}
                  >
                    {I18n.t(
                      "APP_BUSINESS_UNIT_OVERRIDES_IMPORT_FILE_SUBMIT_TEXT"
                    )}
                  </Button>
                  <Button className="submit-button-save" onClick={close}>
                    {I18n.t("APP_BUSINESS_UNIT_OVERRIDES_IMPORT_FILE_CLOSE")}
                  </Button>
                </Row>
              ) : (
                <Row className="spinner-container">
                  <CFASpinner />
                </Row>
              )}
            </CardFooter>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );

  const getLocationNumberByTransactionId = (transactionId: string) => {
    for (const [key, value] of props.riskRecordsModified.current.entries()) {
      const modifiedRefundScores = value as RefundAnomalyScore[];
      const match = modifiedRefundScores.find((modifiedScore) => {
        return modifiedScore.transactionId === transactionId;
      });
      if (match) {
        return key;
      }
    }
    return "Could not find location number";
  }

  const getSubmissionMessageContent = () => {
    if (!duplicateFeedbackRequests || duplicateFeedbackRequests.length < 1) return <></>;

    return (
      <div>
        <div className="partial-save-message-container">{I18n.t("RISK_ANALYSIS_SAVE_PARTIAL_MESSAGE")}</div>
        <table className="partial-save-message-table">
          <tbody>
            <tr>
              <th>Location Number</th>
              <th>Transaction Id</th>
            </tr>
            {duplicateFeedbackRequests.map((request) => {
              return (
                <tr key={request.transactionId}>
                  <td>
                    <b>{getLocationNumberByTransactionId(request.transactionId)}</b>
                  </td>
                  <td key={request.transactionId}>
                    <b>{request.transactionId}</b>
                  </td>
                </tr>
            )
            })}
          </tbody>
        </table>
      </div>
    )
  }

  const submissionCompleteContent = () => {
    if (!duplicateFeedbackRequests || duplicateFeedbackRequests.length < 1) return submissionSuccess;

    return submissionWarning;

  }

  const submissionWarning = (
    <Col className="success-container">
      <h4>{I18n.t("RISK_ANALYSIS_SAVE_PARTIAL_SUCCESS")}</h4>
      {getSubmissionMessageContent()}
      <Button className="go-back-button" block onClick={closeSuccess}>
        {I18n.t("APP_ARMORED_CAR_IMPORT_FILE_CLOSE")}
      </Button>
    </Col>
  );

  const submissionSuccess = (
    <Col className="success-container">
      <img alt="" src={success} className="success-icon" />
      <h4>{I18n.t("RISK_ANALYSIS_SAVE_SUCCESS")}</h4>
      <Button className="go-back-button" block onClick={closeSuccess}>
        {I18n.t("APP_ARMORED_CAR_IMPORT_FILE_CLOSE")}
      </Button>
    </Col>
  );

  return (
    <>
      <Col className="RiskInformationSaveModal container">
        {/*{saveForm}*/}
        {!errorStatus.includes("succeeded") ? (
          <> {saveForm} </>
        ) : (
          <> {submissionCompleteContent()} </>
        )}
      </Col>
    </>
  );
}
export default RiskInformationSaveModal;
